export const receivingDiscrepanciesLookupFieldDropdown =  [
	{
		title: "PO number",
		value: "poNumber"
	},
	{
		title: "Ship Id",
		value: "shipmentId"
	},
	{
		title: "SKU",
		value: "sku"
	},
	{
		title: "Tracking#",
		value: "tackingNumber"
	}
];



// WEBPACK FOOTER //
// ./src/pages/receivingDiscrepancies/filter/receivingDiscrepanciesLookupFieldDropdown.js